import React from 'react';

const Button = ({classList, icon, name}) => {
  return <button className={`${classList}`}>{icon}{name}</button>;
};

export default Button;
